import { Suspense } from 'react';
import { Navigate, useParams } from 'react-router-dom';
import Shimmer from '~/components/Shimmer';
import { ClientSideMenu } from '~/features/ClientSideMenu';
import { EditInternalNews } from '~/features/EditInternalNews';
import { EditInternalNewsHeader } from '~/features/EditInternalNewsHeader';
import { ROUTES } from '~/utils/routes';
import styles from './styles.module.scss';

/**
 * 社内報編集 Screen
 */
export const Screen: React.FC = () => {
  const { id = '' } = useParams<{ id: string }>();

  const newsId = Number.parseInt(id, 10);
  if (Number.isNaN(newsId)) {
    return <Navigate to={ROUTES.INTERNAL_NEWS.INDEX} replace />;
  }

  return (
    <div className={styles.screen}>
      <ClientSideMenu />
      <div className={styles.content}>
        <Suspense fallback={<Shimmer />}>
          <EditInternalNewsHeader newsId={newsId} />
          <main className={styles.body}>
            <EditInternalNews newsId={newsId} />
          </main>
        </Suspense>
      </div>
    </div>
  );
};
